module.exports = __webpack_public_path__ + "87967a536e74bec52951f0bc3bd56b6e.png";